import type { ShadowComparison } from './shadowTransport';

import { trackChatTransportShadowCompared } from '@/util/analyticsEvents';
import { Sentry } from '@/util/sentry';

/**
 * Where shadow comparisons go: every one to analytics, so the match rate can
 * be read off before the toggle moves to `primum`, and each divergence to
 * Sentry as a warning with the counts that describe it.
 */
export function reportShadowComparison(comparison: ShadowComparison): void {
  trackChatTransportShadowCompared({
    conversation_id: comparison.conversationId,
    outcome: comparison.outcome,
    primary_kind: comparison.primaryKind,
    shadow_kind: comparison.shadowKind,
    compared: comparison.compared,
    missing: comparison.missing,
    extra: comparison.extra,
    id_mismatch: comparison.idMismatch,
    body_mismatch: comparison.bodyMismatch,
    attribute_mismatch: comparison.attributeMismatch,
    differing_attribute_keys: comparison.differingAttributeKeys,
  })?.catch(() => undefined);

  if (comparison.outcome === 'match') {
    Sentry.addBreadcrumb({
      category: 'chat.shadow',
      level: 'info',
      message: 'Chat transport shadow matched',
      data: { conversationId: comparison.conversationId, compared: comparison.compared },
    });

    return;
  }

  Sentry.captureMessage('Chat transport shadow diverged', {
    level: 'warning',
    tags: {
      component: 'ShadowChatTransport',
      source: 'chat-transport-shadow',
      outcome: comparison.outcome,
    },
    extra: { ...comparison },
  });
}
